import { EventFrequency } from './eventfrequency';
import { CommunicationEventConfiguration } from './CommunicationEventConfiguration';
import { EventConfiguration } from './eventconfiguration';

export const menu = {
	name: 'DialogueMarketing',
	list: [
		{ name: 'EventConfiguration', route: EventConfiguration.name },
		{ name: 'EventFrequency', route: EventFrequency.name },
		{ name: 'CommunicationEventConfig', route: CommunicationEventConfiguration.name },
	],
};
